import React, { Component } from 'react'
import { BIRTH_MONTH_OPTIONS, DATE_OPTIONS, YEAR_BIRTH_OPTIONS, YEAR_OPTIONS } from '../../../constants'
import { Field, Columns } from 'components/elements'
import { ErrorMessage } from 'formik'

import AddressInputBlock from '../profile/addressFields'

import { licenseFieldProps, licenseFieldsErrorProps } from './licenseFormInitialValues.js'

class LicenseFields extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasData: false,
      hasErrors: false,
      loading: false,
      data: null,
      generalError: false,
    }
  }

  updateValue = (fieldID, value) => {
    this.props.onChange(fieldID, value)
  }

  render() {
    const { errors, licenseData, locked } = this.props
    return (
      //<Form autoComplete="off">
      <>
        <Columns>
          <Columns.Column size={8}>
            <Field
              type="input"
              id="license_number"
              name="license_number"
              placeholder="License Number"
              fullwidth
              label="Driver's License No."
              value={licenseData.license_number}
              onChange={({ value }) => this.updateValue('license_number', value)}
              error={errors.license_number}
              disabled={locked}
            />
          </Columns.Column>
          <Columns.Column size={4}>
            <Field
              type="select"
              placeholder="Gender"
              label="Gender"
              fullwidth
              error={errors.license_gender}
              id="license_gender"
              name="license_gender"
              value={licenseData.license_gender}
              onChange={({ value }) => this.updateValue('license_gender', value)}
              options={[
                {
                  key: 'Male',
                  text: 'Male',
                  value: 'male',
                },
                {
                  key: 'Female',
                  text: 'Female',
                  value: 'female',
                },
              ]}
            />
          </Columns.Column>
        </Columns>

        <Columns>
          <Columns.Column size={4}>
            <Field
              placeholder="First Name"
              type="input"
              label="First Name"
              fullwidth
              id="license_first_name"
              name="license_first_name"
              value={licenseData.license_first_name}
              onChange={({ value }) => this.updateValue('license_first_name', value)}
              disabled={locked}
              error={errors.license_first_name}
            />
          </Columns.Column>
          <Columns.Column size={4}>
            <Field
              placeholder="Middle Name"
              label="Middle Name"
              fullwidth
              id="license_middle_name"
              name="license_middle_name"
              type="input"
              value={licenseData.license_middle_name}
              onChange={({ value }) => this.updateValue('license_middle_name', value)}
              disabled={locked}
              error={errors.license_middle_name}
            />
          </Columns.Column>
          <Columns.Column size={4}>
            <Field
              placeholder="Last Name"
              fullwidth
              label="Last Name"
              id={'license_last_name'}
              name={'license_last_name'}
              value={licenseData.license_last_name}
              onChange={({ value }) => this.updateValue('license_last_name', value)}
              disabled={locked}
              error={errors.license_last_name}
            />
          </Columns.Column>
          <Columns.Column size={12}>
            <p className="is-size-7 has-text-dark-grey" style={{ marginTop: '-1rem' }}>
              Please enter your name as it appears on your license.
            </p>
          </Columns.Column>
        </Columns>
        <label className="label">Birthdate</label>
        <Columns>
          <Columns.Column size={4}>
            <Field
              placeholder="Birth Month"
              fullwidth
              type="select"
              id="license_birth_month"
              name="license_birth_month"
              value={licenseData.license_birth_month}
              onChange={({ value }) => this.updateValue('license_birth_month', value)}
              disabled={locked}
              options={BIRTH_MONTH_OPTIONS}
              error={errors.license_birth_combo}
            />
          </Columns.Column>
          <Columns.Column size={4}>
            <Field
              placeholder="Birth Day"
              fullwidth
              type="select"
              value={licenseData.license_birth_date}
              id="license_birth_date"
              name="license_birth_date"
              onChange={({ value }) => this.updateValue('license_birth_date', value)}
              disabled={locked}
              options={DATE_OPTIONS}
              error={errors.license_birth_combo}
            />
          </Columns.Column>
          <Columns.Column size={4}>
            <Field
              placeholder="Birth Year"
              fullwidth
              type="select"
              value={licenseData.license_birth_year}
              id="license_birth_year"
              name="license_birth_year"
              onChange={({ value }) => this.updateValue('license_birth_year', value)}
              disabled={locked}
              options={YEAR_BIRTH_OPTIONS}
              error={errors.license_birth_combo}
            />
          </Columns.Column>
          <Columns.Column size={12}>
            <p className="is-size-7 has-text-dark-grey" style={{ marginTop: '-1rem' }}>
              You must be 21 or older to rent through Twisted Road.
            </p>

            <ErrorMessage
              className="field-error"
              component="div"
              name="license_birth_combo"
              style={{ paddingLeft: '1rem' }}
            />
          </Columns.Column>
        </Columns>

        <label className="label">Expiration Date</label>
        <Columns>
          <Columns.Column size={4}>
            <Field
              placeholder="Exp Month"
              fullwidth
              value={licenseData.license_exp_month}
              type="select"
              id="license_exp_month"
              name="license_exp_month"
              onChange={({ value }) => this.updateValue('license_exp_month', value)}
              disabled={locked}
              options={BIRTH_MONTH_OPTIONS}
              error={errors.license_exp_combo}
            />
          </Columns.Column>
          <Columns.Column size={4}>
            <Field
              placeholder="Exp Day"
              fullwidth
              value={licenseData.license_exp_date}
              type="select"
              name="license_exp_date"
              id="license_exp_date"
              onChange={({ value }) => this.updateValue('license_exp_date', value)}
              disabled={locked}
              options={DATE_OPTIONS}
              error={errors.license_exp_combo}
            />
          </Columns.Column>
          <Columns.Column size={4}>
            <Field
              placeholder="Exp Year"
              fullwidth
              value={licenseData.license_exp_year}
              type="select"
              name="license_exp_year"
              id="license_exp_year"
              onChange={({ value }) => this.updateValue('license_exp_year', value)}
              disabled={locked}
              options={YEAR_OPTIONS}
              error={errors.license_exp_combo}
            />
          </Columns.Column>
          <Columns.Column size={12}>
            <ErrorMessage
              className="field-error"
              component="div"
              name="license_exp_combo"
              style={{ paddingLeft: '1rem' }}
            />
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column size={12}>
            <AddressInputBlock
              onChange={this.updateValue}
              addressData={{
                address_line_1: licenseData.address_line_1,
                address_line_2: licenseData.address_line_2,
                address_city: licenseData.address_city,
                address_region: licenseData.address_region,
                address_country: licenseData.address_country,
                address_postal_code: licenseData.address_postal_code,
              }}
              locked={locked}
              errors={errors}
            />
            <p className="is-size-7 has-text-dark-grey" style={{ marginTop: '-1rem' }}>
              Enter your address as it appears on your license.
            </p>
          </Columns.Column>
        </Columns>
      </>
    )
  }
}
export default LicenseFields

LicenseFields.defaultProps = {
  licenseData: licenseFieldProps,
  errors: licenseFieldsErrorProps,
  onChange: null,
  locked: false,
}
